import {createTheme, alpha} from '@mui/material/styles';

const BLACK = '#000000';

const defaultTheme = createTheme(); // MUI 기본 테마를 불러오기

const shadows = [...defaultTheme.shadows]; // shadows 배열 가져와서 복사

shadows[1] = `0px 0px 4px ${alpha(BLACK, 0.08)}`; // elevation=1
shadows[2] = `0px 0px 4px ${alpha(BLACK, 0.12)}`; // elevation=2
shadows[3] = `0px 0px 4px ${alpha(BLACK, 0.16)}`; // elevation=3
shadows[4] = `0px 0px 4px ${alpha(BLACK, 0.20)}`; // elevation=4
shadows[5] = `0px 0px 4px ${alpha(BLACK, 0.24)}`; // elevation=5
// 나머지(6 ~ 24)는 MUI 기본값 유지

export default shadows;
